import { captureBreadCrumb, captureError } from "../utils/sentry";

import { handleFormSubmission } from './stripePurchase.js'

const getFormattedPrice = ({ amount, currency }) => {
  return `$${String(amount).slice(0, -2)}.${String(amount).slice(-2)} ${currency}`;  
}

export async function loadProducts () {
  const checkoutFormSubmitElement = document.querySelector('.js-checkout-submit')

  try {
    if (checkoutFormSubmitElement) {
      const products = await fetch('/.netlify/functions/get-products')
        .then((response) => {
          checkoutFormSubmitElement.disabled = false
          return response.json()
        })
        .catch((err) => {
          console.error(err)
          checkoutFormSubmitElement.disabled = true
          throw err
        })

      const product = products.find(product => product.type === 'product')
      captureBreadCrumb({
        message: "Products fetched",
        data: product.prices[0]
      })
      const productPrice = product.prices[0]
      const productPriceFormatted = getFormattedPrice({
        amount: productPrice.amount,
        currency: productPrice.currency,
      })

      const delivery = products.find(product => product.type === 'delivery')
      const deliveryPrice = delivery.prices[0]
      const deliveryPriceFormatted = getFormattedPrice({
        amount: deliveryPrice.amount,
        currency: deliveryPrice.currency,
      })

      const checkoutFormElement = document.querySelector('.js-checkout-form')
      const productSkuInputElement = checkoutFormElement.querySelector('.js-product-sku')
      const deliverySkuInputElement = checkoutFormElement.querySelector('.js-delivery-sku')
      const productImageElement = document.querySelector('.js-product-image')
      const productPriceElement = checkoutFormElement.querySelector('.js-product-price')
      const deliveryPriceElement = checkoutFormElement.querySelector('.js-delivery-price')

      checkoutFormElement.addEventListener('submit', handleFormSubmission)
      productSkuInputElement.value = product.sku
      deliverySkuInputElement.value = delivery.sku
      productImageElement.style.backgroundImage = product.images[0]
      productPriceElement.innerText = productPriceFormatted
      deliveryPriceElement.innerText = deliveryPriceFormatted
    }
  } catch (e) {
    checkoutFormSubmitElement.disabled = true
    captureError(e);
    console.log(e);
  }
}
